"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.THROTTLE_TIME = exports.ActionToFunction = exports.Actions = void 0;
var lodash_1 = require("lodash");
var Subject_1 = require("rxjs/internal/Subject");
var operators_1 = require("rxjs/operators");
var Logger_1 = __importDefault(require("./Logger"));
var Actions;
(function (Actions) {
    Actions["CREATE"] = "CREATE";
    Actions["UPDATE"] = "UPDATE";
    Actions["REMOVE"] = "REMOVE";
    Actions["CLEAR"] = "CLEAR";
})(Actions = exports.Actions || (exports.Actions = {}));
exports.ActionToFunction = (_a = {},
    _a[Actions.CREATE] = 'onCreate',
    _a[Actions.REMOVE] = 'onDelete',
    _a[Actions.UPDATE] = 'onUpdate',
    _a);
exports.THROTTLE_TIME = 1000;
var applyDefaultConfig = function (config) {
    if (config === void 0) { config = {}; }
    return __assign({ realTime: { addItemsWhenHandlingUpdate: true } }, config);
};
var BaseStore = /** @class */ (function () {
    function BaseStore(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        this.onItemUpdateEvents = [];
        this.onItemCreatedEvents = [];
        this.onItemRemovedEvents = [];
        this.onListUpdateEvents = [];
        this.calculations = new Map();
        this._items = new Map();
        this.addCalculation = function (calculationInfo) {
            var uuid = (0, lodash_1.uniqueId)() + Date.now();
            calculationInfo.errors = [];
            calculationInfo.uuid = uuid;
            _this.calculations.set(uuid, calculationInfo);
            return uuid;
        };
        this.removeCalculation = function (uuid) {
            _this.calculations.delete(uuid);
        };
        this.getCalculationValue = function (uuid) {
            var calc = _this.calculations.get(uuid);
            if (!calc) {
                throw new Error('No Calculation with this uuid!');
            }
            return calc.value;
        };
        this.handleCalculations = function (item, type) { return __awaiter(_this, void 0, void 0, function () {
            var calcArray;
            return __generator(this, function (_a) {
                calcArray = Array.from(this.calculations.values());
                calcArray.forEach(function (calculation) {
                    try {
                        var calculationAction = (0, lodash_1.get)(calculation, exports.ActionToFunction[type], lodash_1.noop);
                        calculation.value = calculationAction(calculation.value, item);
                    }
                    catch (error) {
                        calculation.errors.push({
                            type: type,
                            error: error
                        });
                        Logger_1.default.error("BaseStore Failed calculation - for calc: ".concat(calculation.uuid), calculation.errors);
                    }
                });
                return [2 /*return*/];
            });
        }); };
        this.onItemCreated = function (fn) {
            _this.onItemCreatedEvents.push(fn);
            return function () { return _this.onItemCreatedEvents.splice(_this.onItemCreatedEvents.indexOf(fn), 1); };
        };
        this.onItemUpdate = function (fn) {
            _this.onItemUpdateEvents.push(fn);
            return function () { return _this.onItemUpdateEvents.splice(_this.onItemUpdateEvents.indexOf(fn), 1); };
        };
        this.onItemRemoved = function (fn) {
            _this.onItemRemovedEvents.push(fn);
            return function () { return _this.onItemRemovedEvents.splice(_this.onItemRemovedEvents.indexOf(fn), 1); };
        };
        this.onListUpdate = function (fn) {
            _this.onListUpdateEvents.push(fn);
            return function () { return _this.onListUpdateEvents.splice(_this.onListUpdateEvents.indexOf(fn), 1); };
        };
        this.unsubscribe = function () {
            _this.onItemRemovedEvents = [];
            _this.onItemUpdateEvents = [];
            _this.onItemCreatedEvents = [];
            _this.onListUpdateEvents = [];
        };
        this.handleStateUpdate = function (currentState, action) {
            switch (action.type) {
                case Actions.CREATE:
                    return _this._addToStore(currentState, action.payload);
                case Actions.UPDATE:
                    return _this._updateInStore(currentState, action.payload);
                case Actions.REMOVE:
                    return _this._removeFromStore(currentState, action.payload);
                case Actions.CLEAR:
                    return _this._clearStore(currentState);
                default:
                    return currentState;
            }
        };
        this.getItem = function (itemId) {
            return _this._items.get((0, lodash_1.toNumber)(itemId));
        };
        this.getItems = function () {
            return Array.from(_this._items.values());
        };
        this.getItemsByIds = function (ids) {
            var idsSet = new Set(ids);
            return _this.getItems().filter(function (item) { return idsSet.has(item.id); });
        };
        this.getItemsMap = function () {
            return _this._items;
        };
        this.config = applyDefaultConfig(config);
        this.items$ = new Subject_1.Subject();
        this.state$ = this.items$.pipe((0, operators_1.scan)(function (currentState, action) {
            var newState = _this.handleStateUpdate(currentState, action);
            return newState;
        }, new Map()));
        this.state$.pipe((0, operators_1.throttleTime)(exports.THROTTLE_TIME)).subscribe(function (newState) {
            _this._items = newState;
            _this.onListUpdateEvents.forEach(function (fn) { return fn(Array.from(_this._items.values())); });
        });
    }
    BaseStore.prototype.addToStore = function (item) {
        this.items$.next({ type: Actions.CREATE, payload: item });
    };
    BaseStore.prototype.updateInStore = function (item) {
        this.items$.next({ type: Actions.UPDATE, payload: item });
    };
    BaseStore.prototype.removeFromStore = function (itemId) {
        this.items$.next({ type: Actions.REMOVE, payload: itemId });
    };
    BaseStore.prototype.clearStore = function () {
        this.items$.next({ type: Actions.CLEAR, payload: undefined });
    };
    BaseStore.prototype.addItems = function (items) {
        var _this = this;
        items.forEach(function (item) { return _this.addToStore(item); });
    };
    BaseStore.prototype._addToStore = function (currentState, item) {
        var foundItem = currentState.get(item.id);
        if (!foundItem) {
            currentState.set(item.id, item);
            this.onItemCreatedEvents.forEach(function (fn) { return fn(item); });
            this.handleCalculations(item, Actions.CREATE);
        }
        return currentState;
    };
    BaseStore.prototype._updateInStore = function (currentState, item) {
        var foundItem = currentState.get(item.id);
        if (foundItem) {
            foundItem = Object.assign(foundItem, item);
            currentState.set(item.id, foundItem);
            this.onItemUpdateEvents.forEach(function (fn) { return fn(foundItem); });
            this.handleCalculations(item, Actions.UPDATE);
        }
        else if (this.config.realTime.addItemsWhenHandlingUpdate) {
            this._addToStore(currentState, item);
        }
        return currentState;
    };
    BaseStore.prototype._removeFromStore = function (currentState, itemId) {
        var item = currentState.get(itemId);
        currentState.delete(itemId);
        this.onItemRemovedEvents.forEach(function (fn) { return fn(itemId, item); });
        this.handleCalculations(item, Actions.REMOVE);
        return currentState;
    };
    BaseStore.prototype._clearStore = function (currentState) {
        currentState.clear();
        return currentState;
    };
    return BaseStore;
}());
exports.default = BaseStore;
//# sourceMappingURL=BaseStore.js.map